import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d='M14.9524 9.16675L11.2857 12.8334L7.61902 9.16675'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const ArrowChevronDown: React.FC<IconProps> = ({ color, size, ...props }) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{ ...props, size, color }} renderIcon={renderIcon} />
)
